import { FC } from 'react'
import { PoiItem } from './PoiItem.tsx'
import { Poi } from '@/js/types'

type PoiListingProps = {
    pois?: Array<Poi>
    activePoi?: Poi
    itemAction?: (poi: Poi) => void
    flagged?: {
        condition: (poi: Poi) => boolean
        text: string
    }
    hoverAction?: (poi: Poi | null) => void
}

export const PoiListing: FC<PoiListingProps> = ({ pois, activePoi, itemAction, flagged, hoverAction }) => {
    return (
        <div
            className={'flex flex-col flex-1 mb-20 overflow-y-auto'}
            onMouseLeave={() => {
                hoverAction?.(null)
            }}
        >
            {pois && pois.length > 0 ? (
                pois.map((poi) => (
                    <PoiItem
                        poi={poi}
                        key={poi.id}
                        active={activePoi?.id === poi.id}
                        action={(poi) => {
                            hoverAction?.(null)
                            itemAction?.(poi)
                        }}
                        flagged={flagged?.condition(poi) ? flagged?.text : undefined}
                        onHover={(poi) => {
                            hoverAction?.(poi)
                        }}
                    />
                ))
            ) : (
                <div className={'text-mm-gray2 p-5 text-sm'}>Kein Eintrag vorhanden</div>
            )}
        </div>
    )
}
